import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  CUSTOMER_COUNT_CHART,
  IS_PY_GRAPHS,
  REPORTS_BASE_URL,
  REPORTS_CUSTOMER_COUNT_API,
} from "../../../../Constants/Config";
import { useAuthDetails } from "../../../../Common/cookiesHelper";

const initialState = {
  loading: true,
  customerCountData: [],
  totalCustomerCount: 0,
  previousWeekCustomerCount: 0,
  error: "",
  isCancel: false,
};
let controller = null;

export const getCustomerCount = createAsyncThunk(
  "customerCountChart/getCustomerCount.",
  async (data, { rejectWithValue }) => {
    // return []; // set cors error for tetsing as this call is no more in backend
    const { userTypeData } = useAuthDetails();
    if (controller) {
      controller.abort();
    }

    // Create a new AbortController instance for the current request
    controller = new AbortController();
    try {
      const { token, ...otherUserData } = userTypeData;

      const requestData = { ...(data || {}) };
      const activeType =
        requestData?.activeType || requestData?.view_by || requestData?.date_type;
      const isWeek = String(activeType || "").toLowerCase() === "week";

      const dateInYYYYMMDD = (date) => {
        const year = date?.getFullYear();
        const month = String(date?.getMonth() + 1)?.padStart(2, "0");
        const day = String(date?.getDate())?.padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      const parseLocalYMD = (ymd) => {
        const parts = String(ymd || "").split("-");
        if (parts.length !== 3) return null;
        const y = Number(parts[0]);
        const m = Number(parts[1]);
        const d = Number(parts[2]);
        if (!y || !m || !d) return null;
        return new Date(y, m - 1, d);
      };

      const getLocalTodayYMD = () => {
        const now = new Date();
        return dateInYYYYMMDD(
          new Date(now.getFullYear(), now.getMonth(), now.getDate())
        );
      };

      const getWeekStartMonday = (date) => {
        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const day = d.getDay(); // 0=Sun
        const diff = day === 0 ? -6 : 1 - day;
        d.setDate(d.getDate() + diff);
        d.setHours(0, 0, 0, 0);
        return d;
      };

      // ===== WEEK LOGIC =====
      if (isWeek) {
        const minusOneDay = (dateStr) => {
          const date = new Date(dateStr);
          date.setDate(date.getDate());
          return date.toISOString().split("T")[0]; // YYYY-MM-DD
        };
        requestData["date_range"] = `${minusOneDay(requestData.start_date)}_${minusOneDay(requestData.end_date)}`;
        delete requestData["new_date_range"];
      }
      const apiUrl =
        IS_PY_GRAPHS === true || IS_PY_GRAPHS === "true"
          ? REPORTS_BASE_URL + REPORTS_CUSTOMER_COUNT_API
          : BASE_URL + CUSTOMER_COUNT_CHART;

      const response = await axios.post(
        apiUrl,
        { ...requestData, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        }
      );


      let total_customer_count = 0;

      if (isWeek) {
        const resultArray = response?.data?.filter_customer_count || [];
        console.log("resultArray", resultArray);
        let total = 0;
        if (Array.isArray(resultArray)) {
          resultArray.forEach((row) => {
            total += +row?.total_customer || 0;
          });
        }

        // const filter_revenue_data = dateKeys.map((d) => ({
        //   total_revenue: parseFloat((total || 0).toFixed(2)),
        //   sale_count: 0,
        // }));
        total_customer_count = total;
        console.log("total_customer_count", total_customer_count);
        return {
          ...response?.data,
          sale_count_data: resultArray,
          total_customer_count: total_customer_count,
        };
      }
      total_customer_count =
        response?.data?.total_customer_count ?? response?.data?.filter_customer_count ?? 0;

      return {
        ...response?.data,
        total_customer_count: total_customer_count,
      };



    } catch (error) {
      if (axios.isCancel(error) || error.name === "CanceledError") {
        return rejectWithValue({ isCanceled: true }); // Mark as canceled
      }
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const customerCountChartSlice = createSlice({
  name: "customerCountChart",
  initialState,
  reducers: {
    clearCustomerCountChart: (state, action) => {
      state.loading = true;
      state.customerCountData = [];
      state.totalCustomerCount = 0;
      state.previousWeekCustomerCount = 0;
      state.error = "";
      state.isCancel = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomerCount.pending, (state) => {
      state.loading = true;
      state.isCancel = false;
    });
    builder.addCase(getCustomerCount.fulfilled, (state, action) => {
      state.loading = false;
      state.customerCountData = action.payload?.filter_customer_count || [];
      state.totalCustomerCount = action.payload?.total_customer_count || 0;
      state.previousWeekCustomerCount = action.payload?.previous_customer_count || 0;
      state.error = "";
      state.isCancel = false;
    });
    builder.addCase(getCustomerCount.rejected, (state, action) => {
      state.loading = false;
      state.customerCountData = [];
      state.totalCustomerCount = 0;
      state.previousWeekCustomerCount = 0;
      state.error = action.error.message;
      state.isCancel = action.payload.isCanceled;
    });
  },
});

export const { clearCustomerCountChart } = customerCountChartSlice.actions;
export default customerCountChartSlice.reducer;

